
import React, { Component } from "react";

import { Pagination } from 'antd';

import '../css/widget/widget.pagination.css'

class WidgetPagination extends Component 
{
    constructor (props) {
        super(props);

        this.state = {
        }
    }

    pageChange = (page, pageSize) => {

        if( this.props.pageChange )
        {
            this.props.pageChange(page, pageSize);
        }
    }

    render() 
    {
        const {page, total, pageSize, pageSizeOptions, showQuickJumper=true, showSizeChanger=true} = this.props;

        return  (
            <div className="sf-pagination sd-pagination sg-pagination">
                <Pagination 
                    defaultCurrent={page} 
                    total={total} 
                    pageSize={pageSize}
                    pageSizeOptions={pageSizeOptions}
                    onChange={this.pageChange}
                    showSizeChanger={showSizeChanger}
                    showQuickJumper={showQuickJumper}
                />
            </div>
        )
    }
}

export default WidgetPagination;